import {useEffect} from "react";

import {signInAnonymously} from "firebase/auth";

import GameSoundEffects from "~/contexts/audio/GameSoundEffects";
import CameraProvider from "~/contexts/camera/CameraProvider";
import {GameStateProvider} from "~/contexts/gamestate/GameStateProvider";
import {LevelLoaderProvider} from "~/contexts/loader/LevelLoaderContext";

import {useCurrentUserSettingsRealtimeSub} from "./api/hooks/useSettings";
import {AudioProvider} from "./contexts/audio/AudioProvider";
import {GlobalEventBusProvider} from "./contexts/event/GlobalEventBusContext";
import {GameManagerProvider} from "./contexts/game-manager/GameManagerProvider";
import {GroupProvider} from "./contexts/group/GroupProvider";
import LogViewer from "./contexts/logging/LogViewer";
import {LoggingProvider} from "./contexts/logging/LoggingProvider";
import {GroupSessionProvider} from "./contexts/session/GroupSessionProvider";
import {ServerTimeProvider} from "./contexts/time/ServerTimeProvider";
import {UserInputCoordinatorProvider} from "./contexts/user-input/UserInputCoordinatorProvider";
import {UserInteractionProvider} from "./contexts/userInteraction/UserInteractionContext";
import {auth} from "./firebase/firebase";
import "./i18n";
import Layout from "./routes/Layout";
import {SelectionProvider} from "./three/selection/SelectionProvider";

function App() {
  useCurrentUserSettingsRealtimeSub();

  useEffect(() => {
    signInAnonymously(auth);
  }, []);

  return (
    <ServerTimeProvider>
      <GameManagerProvider>
        <GroupProvider>
          <GroupSessionProvider>
            <GlobalEventBusProvider>
              <UserInteractionProvider>
                <AudioProvider>
                  <CameraProvider>
                    <GameStateProvider>
                      <SelectionProvider>
                        <LevelLoaderProvider>
                          <UserInputCoordinatorProvider>
                            <LoggingProvider>
                              <Layout />
                              <LogViewer />
                              <GameSoundEffects />
                            </LoggingProvider>
                          </UserInputCoordinatorProvider>
                        </LevelLoaderProvider>
                      </SelectionProvider>
                    </GameStateProvider>
                  </CameraProvider>
                </AudioProvider>
              </UserInteractionProvider>
            </GlobalEventBusProvider>
          </GroupSessionProvider>
        </GroupProvider>
      </GameManagerProvider>
    </ServerTimeProvider>
  );
}

export default App;
